const headers = [
  {
    text: 'sale.sale_ship-destdate',
    value: 'shipDate',
    width: '100px'
  },
  {
    text: 'ship.ship_ship-storage',
    value: 'storage.name',
    width: '90px'
  },
  {
    text: 'ship.ship_ship-user',
    value: 'userId',
    width: '90px'
  },
  {
    text: 'sale.sale_customer',
    value: 'sale.customerId',
    width: '180px'
  },
  {
    text: 'sale.sale_status',
    value: 'status'
  }
]

const tableKey = 'shipId'

const productListHeaders = [
  {
    text: 'product.product_product-number',
    value: 'product.productNumber',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_product-name',
    value: 'productName',
    sortable: false,
    width: '30%',
    class: 'rgba(151, 198, 234, 0.1)'
  },
  {
    text: 'common.product_capacity',
    value: 'product.capacity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'ship.ship_ship-quantity-lot-number',
    value: 'quantityAndStorageNoForShip',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'end'
  }
]

export default { headers, tableKey, productListHeaders }
